class ImpactVariantRadios extends HTMLElement {
  constructor() {
    super();
    impactSliderInit(true);
    this.addEventListener('change', this.onVariantChange);

    this.deselectButton = this.querySelector('.product-form__group-reset');
    this.deselectButton?.addEventListener('click', this.onDeselect.bind(this));
    this.currentFreePrice = false;
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updateVariantStatuses();
    this.updateFreePrice();
    if (this.currentVariant) {
      this.updateVariantInput();
      this.filterMedia(this.currentVariant.title);
    } else {
      // this.setUnavailable();
    }
  }

  onDeselect() {
    this.querySelectorAll('input[type="radio"]').forEach((input) => {
      input.checked = false;
    });
    this.options = [];
    this.currentVariant = null;
    this.currentImpactPrice = null;
    this.currentFreePrice = false;
    this.updateVariantStatuses();
    this.updateVariantInput();
    document.querySelector('variant-radios')?.updatePrice();
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('fieldset')).map(
      (fs) => Array.from(fs.querySelectorAll('input')).find((input) => input.checked).value
    );
  }

  updateMasterId() {
    const data = this.getVariantData();
    this.currentVariant = data.find((variant) => variant.options.every((opt, idx) => this.options[idx] === opt));
  }

  updateCurrentImpactPrice() {
    const data = this.getVariantData();
    this.currentImpactPrice = data.find((variant) => variant.options.every((opt, idx) => this.options[idx] === opt));
  }

  updateFreePrice() {
    const checkedInput = this.querySelector('input[type="radio"]:checked');
    this.currentFreePrice = checkedInput?.hasAttribute('data-free-price') || false;
  }

  getVariantData() {
    if (!this.variantData) {
      const json = this.querySelector('[type="application/json"]');
      if (json) this.variantData = JSON.parse(json.textContent);
    }
    return this.variantData;
  }

  filterMedia(variantTitle) {
    const swiper = document.querySelector('.js-impact-slider')?.swiper;
    if (swiper) {
      filterSlides(swiper, null, pascalize(variantTitle));
    }
  }

  updateVariantInput() {
    const formSelectors = this.dataset.index
      ? `#product-form-${this.dataset.section}-${this.dataset.index}, #product-form-installment-${this.dataset.section}-${this.dataset.index}`
      : `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`;
    document.querySelectorAll(formSelectors).forEach((form) => {
      const input = form.querySelector('input[name="items[0]id"]');
      const properties = form.querySelector('input[name="items[0]properties[_upsell]"]');
      input.disabled = !this.currentVariant;
      properties.disabled = !this.currentVariant;
      input.value = this.currentVariant?.id || '';
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    document.querySelector('variant-radios')?.updatePrice();
  }

  updateVariantStatuses() {
    const checked = this.querySelector(':checked');

    if (!checked) {
      const controls = [...this.querySelectorAll('.product-form__controls')];
      controls.forEach((control, i) => {
        if (i === 0) return;
        const inputs = [...control.querySelectorAll('input[type="radio"], option')];
        inputs.forEach((input) => input.classList.remove('disabled'));
      });
      return;
    }

    const group = this.variantData.filter((v) => checked.value === v.option1);
    const controls = [...this.querySelectorAll('.product-form__controls')];
    controls.forEach((control, i) => {
      if (i === 0) return;
      const inputs = [...control.querySelectorAll('input[type="radio"], option')];
      const prevValue = controls[i - 1].querySelector(':checked').value;
      const available = group
        .filter((v) => v.available && v[`option${i}`] === prevValue)
        .map((v) => v[`option${i + 1}`]);
      this.setInputAvailability(inputs, available);
    });
  }

  setInputAvailability(inputs, availableValues) {
    inputs.forEach((input) => {
      input.classList.toggle('disabled', !availableValues.includes(input.getAttribute('value')));
    });
  }
}
customElements.define('impact-variant-radios', ImpactVariantRadios);
